const red = Object.freeze({
  base: '#FF0000',
  lighten5: '#ffebee',
  lighten4: '#ffcdd2',
  lighten3: '#ef9a9a',
  lighten2: '#e57373',
  lighten1: '#ef5350',
  darken1: '#e53935',
  darken2: '#d32f2f',
  darken3: '#c62828',
  darken4: '#b71c1c',
  accent1: '#ff8a80',
  accent2: '#ff5252',
  accent3: '#ff1744',
  accent4: '#d50000'
})
const pink = Object.freeze({
  base: '#e91e63',
  lighten5: '#fce4ec',
  lighten4: '#f8bbd0',
  lighten3: '#f48fb1',
  lighten2: '#f06292',
  lighten1: '#ec407a',
  darken1: '#d81b60',
  darken2: '#c2185b',
  darken3: '#ad1457',
  darken4: '#880e4f',
  accent1: '#ff80ab',
  accent2: '#ff4081',
  accent3: '#f50057',
  accent4: '#c51162'
})
const purple = Object.freeze({
  base: '#9c27b0',
  lighten5: '#f3e5f5',
  lighten4: '#e1bee7',
  lighten3: '#ce93d8',
  lighten2: '#ba68c8',
  lighten1: '#ab47bc',
  darken1: '#8e24aa',
  darken2: '#7b1fa2',
  darken3: '#6a1b9a',
  darken4: '#4a148c',
  accent1: '#ea80fc',
  accent2: '#e040fb',
  accent3: '#d500f9',
  accent4: '#aa00ff'
})
const deepPurple = Object.freeze({
  base: '#673ab7',
  lighten5: '#ede7f6',
  lighten4: '#d1c4e9',
  lighten3: '#b39ddb',
  lighten2: '#9575cd',
  lighten1: '#7e57c2',
  darken1: '#5e35b1',
  darken2: '#512da8',
  darken3: '#4527a0',
  darken4: '#311b92',
  accent1: '#b388ff',
  accent2: '#7c4dff',
  accent3: '#651fff',
  accent4: '#6200ea'
})
const indigo = Object.freeze({
  base: '#2e4470',
  lighten5: '#2e4470',
  lighten4: '#2e4470',
  lighten3: '#2e4470',
  lighten2: '#2e4470',
  lighten1: '#2e4470',
  darken1: '#2e4470',
  darken2: '#2e4470',
  darken3: '#2e4470',
  darken4: '#2e4470',
  accent1: '#2e4470',
  accent2: '#2e4470',
  accent3: '#2e4470',
  accent4: '#2e4470'
})
const blue = Object.freeze({
  base: '#2196f3',
  lighten5: '#e3f2fd',
  lighten4: '#bbdefb',
  lighten3: '#90caf9',
  lighten2: '#64b5f6',
  lighten1: '#42a5f5',
  darken1: '#1e88e5',
  darken2: '#1976d2',
  darken3: '#1565c0',
  darken4: '#0d47a1',
  accent1: '#82b1ff',
  accent2: '#448aff',
  accent3: '#2979ff',
  accent4: '#2962ff'
})
const cyan = Object.freeze({
  base: '#00bcd4',
  lighten5: '#e0f7fa',
  lighten4: '#b2ebf2',
  lighten3: '#80deea',
  lighten2: '#4dd0e1',
  lighten1: '#26c6da',
  darken1: '#00acc1',
  darken2: '#0097a7',
  darken3: '#00838f',
  darken4: '#006064',
  accent1: '#84ffff',
  accent2: '#18ffff',
  accent3: '#00e5ff',
  accent4: '#00b8d4'
})
const teal = Object.freeze({
  base: '#009688',
  lighten5: '#e0f2f1',
  lighten4: '#b2dfdb',
  lighten3: '#80cbc4',
  lighten2: '#4db6ac',
  lighten1: '#26a69a',
  darken1: '#00897b',
  darken2: '#00796b',
  darken3: '#00695c',
  darken4: '#004d40',
  accent1: '#a7ffeb',
  accent2: '#64ffda',
  accent3: '#1de9b6',
  accent4: '#00bfa5'
})
const green = Object.freeze({
  base: '#4caf50',
  lighten5: '#e8f5e9',
  lighten4: '#c8e6c9',
  lighten3: '#a5d6a7',
  lighten2: '#81c784',
  lighten1: '#66bb6a',
  darken1: '#43a047',
  darken2: '#388e3c',
  darken3: '#2e7d32',
  darken4: '#1b5e20',
  accent1: '#b9f6ca',
  accent2: '#69f0ae',
  accent3: '#00e676',
  accent4: '#00c853'
})
const lightGreen = Object.freeze({
  base: '#8bc34a',
  lighten5: '#f1f8e9',
  lighten4: '#dcedc8',
  lighten3: '#c5e1a5',
  lighten2: '#aed581',
  lighten1: '#9ccc65',
  darken1: '#7cb342',
  darken2: '#689f38',
  darken3: '#558b2f',
  darken4: '#33691e',
  accent1: '#ccff90',
  accent2: '#b2ff59',
  accent3: '#76ff03',
  accent4: '#64dd17'
})
const lime = Object.freeze({
  base: '#cddc39',
  lighten5: '#f9fbe7',
  lighten4: '#f0f4c3',
  lighten3: '#e6ee9c',
  lighten2: '#dce775',
  lighten1: '#d4e157',
  darken1: '#c0ca33',
  darken2: '#afb42b',
  darken3: '#9e9d24',
  darken4: '#827717',
  accent1: '#f4ff81',
  accent2: '#eeff41',
  accent3: '#c6ff00',
  accent4: '#aeea00'
})
const yellow = Object.freeze({
  base: '#ffeb3b',
  lighten5: '#fffde7',
  lighten4: '#fff9c4',
  lighten3: '#fff59d',
  lighten2: '#fff176',
  lighten1: '#ffee58',
  darken1: '#fdd835',
  darken2: '#fbc02d',
  darken3: '#f9a825',
  darken4: '#f57f17',
  accent1: '#ffff8d',
  accent2: '#ffff00',
  accent3: '#ffea00',
  accent4: '#ffd600'
})
const amber = Object.freeze({
  base: '#ffc107',
  lighten5: '#fff8e1',
  lighten4: '#ffecb3',
  lighten3: '#ffe082',
  lighten2: '#ffd54f',
  lighten1: '#ffca28',
  darken1: '#ffb300',
  darken2: '#ffa000',
  darken3: '#ff8f00',
  darken4: '#ff6f00',
  accent1: '#ffe57f',
  accent2: '#ffd740',
  accent3: '#ffc400',
  accent4: '#ffab00'
})
const orange = Object.freeze({
  base: '#ff9800',
  lighten5: '#fff3e0',
  lighten4: '#ffe0b2',
  lighten3: '#ffcc80',
  lighten2: '#ffb74d',
  lighten1: '#ffa726',
  darken1: '#fb8c00',
  darken2: '#f57c00',
  darken3: '#ef6c00',
  darken4: '#e65100',
  accent1: '#ffd180',
  accent2: '#ffab40',
  accent3: '#ff9100',
  accent4: '#ff6d00'
})
const deepOrange = Object.freeze({
  base: '#ff5722',
  lighten5: '#fbe9e7',
  lighten4: '#ffccbc',
  lighten3: '#ffab91',
  lighten2: '#ff8a65',
  lighten1: '#ff7043',
  darken1: '#f4511e',
  darken2: '#e64a19',
  darken3: '#d84315',
  darken4: '#bf360c',
  accent1: '#ff9e80',
  accent2: '#ff6e40',
  accent3: '#ff3d00',
  accent4: '#dd2c00'
})
const brown = Object.freeze({
  base: '#795548',
  lighten5: '#efebe9',
  lighten4: '#d7ccc8',
  lighten3: '#bcaaa4',
  lighten2: '#a1887f',
  lighten1: '#8d6e63',
  darken1: '#6d4c41',
  darken2: '#5d4037',
  darken3: '#4e342e',
  darken4: '#3e2723'
})
const blueGrey = Object.freeze({
  base: '#607d8b',
  lighten5: '#eceff1',
  lighten4: '#cfd8dc',
  lighten3: '#b0bec5',
  lighten2: '#90a4ae',
  lighten1: '#78909c',
  darken1: '#546e7a',
  darken2: '#455a64',
  darken3: '#37474f',
  darken4: '#263238'
})
const shades = Object.freeze({
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent'
})
// Telekom colors
const magenta = Object.freeze({
  base: '#E20074',
  lighten1: '#FC1A8E',
  lighten2: '#FF33A7',
  lighten3: '#FF4DC1',
  lighten4: '#FF66DA',
  lighten5: '#FF7FF3',
  darken1: '#C9005B',
  darken2: '#AF0041',
  darken3: '#960028',
  darken4: '#7C000E'
})
const grey = Object.freeze({
  base: '#999999',
  lighten1: '#B3B3B3',
  lighten2: '#CCCCCC',
  darken1: '#808080',
  darken2: '#666666'
})
// Bosch colors
const boschred = Object.freeze({
  base: '#E20015',
  lighten1: '#FC1A2F',
  lighten2: '#FF3348',
  lighten3: '#FF4D62',
  lighten4: '#FF667B',
  lighten5: '#FF7F94',
  darken1: '#C90000',
  darken2: '#AF0000',
  darken3: '#960000',
  darken4: '#7C0000'
})
const fuchsia = Object.freeze({
  base: '#b90276',
  lighten1: '#D31C90',
  lighten2: '#EC35A9',
  lighten3: '#FF4FC3',
  lighten4: '#FF68DC',
  darken1: '#A0005D',
  darken2: '#860043',
  darken3: '#6D002A',
  darken4: '#530010'
})
const violet = Object.freeze({
  base: '#50237f'
})
const darkblue = Object.freeze({
  base: '#005691'
})
const lightblue = Object.freeze({
  base: '#008ecf'
})
const turquoise = Object.freeze({
  base: '#00a8b0'
})
const lightgreen = Object.freeze({
  base: '#78be20'
})
const darkgreen = Object.freeze({
  base: '#006249'
})
const boschlightgrey = Object.freeze({
  base: '#bfc0c2'
})
const boschdarkgrey = Object.freeze({
  base: '#525f6b'
})
const black = Object.freeze({
  base: '#000000'
})
// BOTFriends Colors
const bfDarkBlue = Object.freeze({
  darken4: '#0d1023',
  darken3: '#121730',
  darken2: '#171f3d',
  darken1: '#1d2749',
  base: '#223056',
  lighten1: '#283a63',
  lighten2: '#2e4470',
  lighten3: '#35507c',
  lighten4: '#3b5b89',
  lighten5: '#426996'
})
const bfLightBlue = Object.freeze({
  darken4: '#46b9d3',
  darken3: '#5ec0d6',
  darken2: '#70c7da',
  darken1: '#82cee0',
  base: '#94d5e4',
  lighten1: '#a5dbe7',
  lighten2: '#b7e3ec',
  lighten3: '#caeaf1',
  lighten4: '#dbf1f6',
  lighten5: '#eef8fb'
})
const bfGrey = Object.freeze({
  darken4: '#a1a1a2',
  darken3: '#aaaaab',
  darken2: '#b3b3b4',
  darken1: '#bdbdbd',
  base: '#c6c6c7',
  lighten1: '#d0d0d0',
  lighten2: '#d9d9d9',
  lighten3: '#e2e2e3',
  lighten4: '#ececec',
  lighten5: '#f5f5f5'
})

export default {
  bfDarkBlue,
  bfLightBlue,
  bfGrey,
  magenta,
  grey,
  boschred,
  fuchsia,
  violet,
  darkblue,
  lightblue,
  turquoise,
  lightgreen,
  darkgreen,
  boschlightgrey,
  boschdarkgrey,
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,
  blueGrey,
  shades,
  black
}
